'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { CheckXs } from '@lichtblick/photon/icons/symbols/check-xs';
import { CopyXs } from '@lichtblick/photon/icons/technology/copy-xs';
import { useCallback, useEffect, useRef, useState } from 'react';
export const CopyButton = ({ text })=>{
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef(undefined);
    useEffect(()=>{
        timeoutRef.current = setTimeout(()=>{
            setCopied(false);
        }, 2500);
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const clickHandler = useCallback(async ()=>{
        try {
            await navigator.clipboard.writeText(text ?? '');
            setCopied(true);
        } catch (_error) {
        // bad luck
        }
    }, [
        text
    ]);
    return /*#__PURE__*/ _jsx(TextCTA, {
        ariaLabel: "Bonuscode kopieren",
        as: "button",
        icon: copied ? /*#__PURE__*/ _jsx(CheckXs, {}) : /*#__PURE__*/ _jsx(CopyXs, {}),
        onClick: clickHandler,
        type: "button"
    });
};

//# sourceMappingURL=copy-button.js.map